import React, { FC, useState } from 'react';
import { MdSearch as SearchIcon } from '@react-icons/all-files/md/MdSearch';
import { MdClose as CrossIcon } from '@react-icons/all-files/md/MdClose';
import { createUseStyles } from 'react-jss';
import clsx from 'clsx';

const useStyles = createUseStyles({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: '#fff',
    borderRadius: 20,
    border: '1px solid #f1f1f1',
    boxShadow: '0 6px 12px -5px rgba(65,76,78,.08)',
    padding: '5px 5px 5px 20px',
  },
  emptyQuery: {},
  resetBttn: {
    cursor: 'pointer',
    marginLeft: '.25rem',
    transition: '250ms',
    '&$emptyQuery': {
      width: 0,
      overflow: 'hidden',
    },
  },
  input: {
    width: '100%',
    background: 'transparent',
    border: 'none',
    borderRadius: 0,
    padding: 0,
    lineHeight: '30px',
  },
});

interface Props {
  className: any;
  onQueryChange: (newValue: string) => void;
}

const SearchBar: FC<Props> = ({ className, onQueryChange }) => {
  const [searchBarRef, setSearchBarRef] = useState<HTMLElement | null>(null);
  const [isResultOpen, setIsResultOpen] = useState(false);
  const [value, setValue] = useState<string>();

  const classes = useStyles();

  const handleReset = () => {
    setIsResultOpen(false);
    onQueryChange('');
  };

  const handleQueryChange = (event) => {
    const target = event.target;
    const value = target.value;

    setValue(value);
    onQueryChange(value);
  };

  return (
    <div className={clsx(className, classes.root)}>
      <input
        value={value || ''}
        onClick={() => setIsResultOpen(true)}
        onChange={handleQueryChange}
        className={classes.input}
        type='text'
        placeholder='Recherche client ...'
      />

      <CrossIcon
        size={20}
        className={clsx(classes.resetBttn, { [classes.emptyQuery]: !value || value.length <= 0 })}
        onClick={handleReset}
      />

      <SearchIcon size={20} style={{ marginLeft: '.25rem', marginRight: '.25rem' }} />
    </div>
  );
};

export default SearchBar;
